import { createMutation } from "react-query-kit";
import type { MutationFunction } from "@tanstack/react-query";

import type { IPickMutation } from "../../types";
import { getApi } from "../../apiPath";
import { axiosClient, queryClient } from "../../clients";

import { useGetUserNotificationSetting } from "./get";
import type { IUserNotificationSettings } from "./routeType";

const { getPath } = getApi("users.notification.patch");

type IExtractedRouteType =
  IUserNotificationSettings["usersNotificationsSettingsPartialUpdate"];

export type IPatchUsersNotificationSettings =
  IPickMutation<IExtractedRouteType>;

export const patchUserNotificationSetting: MutationFunction<
  IPatchUsersNotificationSettings["response"],
  IPatchUsersNotificationSettings["variables"]
> = ({ userId, ...data }) => {
  return axiosClient.patch(getPath({ userId }), data);
};

export const usePatchUserNotificationSetting = createMutation({
  mutationFn: patchUserNotificationSetting,
  onSuccess: (_, { userId }) => {
    queryClient.invalidateQueries({
      queryKey: useGetUserNotificationSetting.getKey({ userId }),
    });
  },
});
